import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-container-col login-container" }
const _hoisted_2 = { class: "login-panel" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 1,
  class: "flex-container-col gap20",
  style: {"align-items":"flex-start"}
}
const _hoisted_6 = {
  key: 0,
  style: {"align-self":"center"}
}
const _hoisted_7 = {
  key: 1,
  class: "flex-container-col gap20"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "flex-container-col gap20" }
const _hoisted_10 = { class: "flex-container-row gap40" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_error = _resolveComponent("error")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isMaintenanceMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", { innerHTML: _ctx.maintenanceMessage }, null, 8, _hoisted_4)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1),
            (_ctx.inProgress)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_loader, { size: "40%" })
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_ctx.errorMessage)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _createVNode(_component_error, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.errorMessage), 1)
                          ]),
                          _: 1
                        })
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_9, [
                    _renderSlot(_ctx.$slots, "default")
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links, (link, index) => {
                      return (_openBlock(), _createBlock(_component_router_link, {
                        key: index,
                        to: link.url
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(link.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"]))
                    }), 128))
                  ])
                ]))
          ]))
    ])
  ]))
}